import restaurantMealActions from '../actionTypes/restaurantMealActions';


const initialState = {
  data: [],
  isLoading: false,
  isSuccess: false,
  isFailure: false,
};

const restaurantMealReducer = (state = initialState, action) => {
  switch (action.type) {
    case restaurantMealActions.getRestaurantMeal:
      return {
        ...state,
        ...action.payload,
        isLoading: true,
        isSuccess: false,
        isFailure: false,
      };
    case restaurantMealActions.getRestaurantMealSuccess:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      };
    case restaurantMealActions.getRestaurantMealFailed:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      };

    case restaurantMealActions.updateMealStatusSuccess:
      const { id } = action.payload.data;
      const updatedData = state.data.meals.map((mealItem) => {
        if (mealItem.id === parseInt(id)) {
          const currentMealStatus = mealItem.is_active;
          return {
            ...mealItem,
           is_active: !currentMealStatus ,
          };
        }
        return mealItem;
      });
      return {
        ...state,
        data: { ...state.data, meals: updatedData },
      };

    case restaurantMealActions.addRestaurantMealSuccess:
      return {
        ...state,
        isLoading: false,
        isSuccess: true,
        isFailure: false,
      };

    case restaurantMealActions.addRestaurantMealFailure:
      return {
        ...state,
        isLoading: false,
        isFailure: true,
        isSuccess: false,
      };
    case restaurantMealActions.editRestaurantMealFailure:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      }
    default:
      return state;
  }
};

export default restaurantMealReducer;
